import {
  LANG_PREFIX,
  PREFIXED_LANGS,
  type AppLang,
  type PrefixedLang,
} from "@/locale/appLang";

/** Устаревший префикс русской версии. `/` теперь = ru. */
export const LEGACY_RU_PATH_PREFIX = "/ru";

export const UK_PATH_PREFIX = LANG_PREFIX.uk;
export const KY_PATH_PREFIX = LANG_PREFIX.ky;
export const KK_PATH_PREFIX = LANG_PREFIX.kk;
export const UZ_PATH_PREFIX = LANG_PREFIX.uz;

export function prefixForLang(lang: AppLang): string | null {
  if (lang === "ru") return null;
  return LANG_PREFIX[lang as PrefixedLang];
}

/**
 * Разбирает pathname на базовый путь и язык.
 * `/` → ru · `/uk|kk|uz|ky/...` → соответствующая локаль · `/ru/...` → ru (legacy)
 */
export function parseLocalePath(pathname: string): { basePath: string; lang: AppLang } {
  const raw = pathname.split("?")[0].split("#")[0];
  const trimmed = raw.replace(/\/+$/, "") || "/";

  for (const lang of PREFIXED_LANGS) {
    const prefix = LANG_PREFIX[lang];
    if (trimmed === prefix) {
      return { basePath: "/", lang };
    }
    if (trimmed.startsWith(`${prefix}/`)) {
      const rest = trimmed.slice(prefix.length) || "/";
      return { basePath: rest.startsWith("/") ? rest : `/${rest}`, lang };
    }
  }

  if (trimmed === LEGACY_RU_PATH_PREFIX) {
    return { basePath: "/", lang: "ru" };
  }
  if (trimmed.startsWith(`${LEGACY_RU_PATH_PREFIX}/`)) {
    const rest = trimmed.slice(LEGACY_RU_PATH_PREFIX.length) || "/";
    return { basePath: rest.startsWith("/") ? rest : `/${rest}`, lang: "ru" };
  }

  return { basePath: trimmed, lang: "ru" };
}

/** Путь с учётом языка; со слэшем (кроме `/`) — как CF Pages directory index. */
export function localizedPath(basePath: string, lang: AppLang): string {
  const base = basePath.startsWith("/") ? basePath : `/${basePath}`;
  const normalized = base.replace(/\/+$/, "") || "/";
  const prefix = prefixForLang(lang);
  const pathOut = prefix
    ? normalized === "/"
      ? prefix
      : `${prefix}${normalized}`
    : normalized;
  if (pathOut === "/") return "/";
  return pathOut.endsWith("/") ? pathOut : `${pathOut}/`;
}

export function isLegacyRuPath(pathname: string): boolean {
  const raw = pathname.split("?")[0].split("#")[0];
  const trimmed = raw.replace(/\/+$/, "") || "/";
  return trimmed === LEGACY_RU_PATH_PREFIX || trimmed.startsWith(`${LEGACY_RU_PATH_PREFIX}/`);
}
